export { default } from './AlertText';